<template>
    <div>
      <!-- THUMBS CAROUSEl -->
      <section class="text-center">
        <!-- CONTAINER -->
        <div class="container">

          <h1 class="font-size-xLarge font-size-lg-xxxLarge">Um <span class="font-weight-bold text-color2">ambiente perfeito</span> para <br class="d-none d-md-block" />todos os tipos de histórias.</h1>
          <p>Veja o que as pessoas estão publicando.</p>

          <PostThumbCarousel
            v-if="posts"
            :posts="posts"
          />

          <div class="text-center mt-5">
            <Button type="button" class="btn btn-primary btn-lg" v-b-modal.auth-modal>
              Começar agora
            </Button>
          </div>

          <hr class="no-border h-1 background-color2 w-75 my-5" />

        </div> <!-- END CONTAINER -->
      </section> <!-- END THUMBS CAROUSEL -->

      <!-- ABOUT -->
      <section>
        <div class="container">
          <!-- READER -->
          <div class="text-center d-flex flex-column flex-lg-row align-items-lg-center justify-content-center">
            <div class="text-lg-left col-lg-4">
              <h2 class="font-size-xLarge">Onde escritores <br/>e leitores se <br/><span class="highlighted highlight-left">encontram</span></h2>
            </div>
            <div class="mt-4 col-lg-8 text-lg-left">
              <p class="quoted">Somos muito mais que uma rede social! Somos um espaço seguro e democrático, criado para pequenos autores escreverem e compartilharem textos, contos, opiniões e histórias e encontrarem o seu público.</p>
            </div>
          </div><!-- END READER -->

          <!-- WRITERS -->
          <div class="text-center mt-5 d-flex flex-column flex-lg-row align-items-lg-center justify-content-center">
            <div class="order-lg-2 text-lg-left col-lg-4 pl-lg-5">
              <h2 class="font-size-xLarge">Empoderando <br/><span class="highlighted highlight-right">criadores</span> <br/><span class="highlighted highlight-right">de conteúdo</span></h2>
            </div>
            <div class="mt-4 order-lg-1 text-lg-left col-lg-8">
              <p class="quoted">Gostamos de histórias. Aquelas que nos fazem rir, refletir e as que nos apresentam novos pontos de vista. Acreditamos que mais boas histórias podem surgir através de um público que motive e desafie os autores. Essa é a nossa força motriz: construir comunidades e aumentar o alcance dos nossos criadores.</p>
            </div>
          </div> <!-- END WRITERS -->

          <hr class="no-border h-1 background-color2 w-75 my-5" />

        </div>
      </section> <!-- END ABOUT -->

      <!-- TESTIMONIALS -->
      <section class="py-4 mb-5">
        <div class="container">
          <TestimonialCarousel
            :testimonials="testimonials"
          />
        </div>
      </section> <!-- END TESTIMONIALS -->

      <section class="text-center">
        <div class="container">
          <h2 class="font-size-xLarge">Não perca tempo <br class="d-none d-md-block" />e junte-se à comunidade</h2>
          <Button type="button" class="btn btn-primary btn-lg mt-5" v-b-modal.auth-modal>
            Começar agora
          </Button>
        </div>
      </section>
    </div>
</template>

<script>

import FeedService from '@/modules/feed/services/feed-service'

import Button from '@/components/common/Button/Button.vue'
import PostThumbCarousel from '@/components/post/PostThumbCarousel.vue'
import TestimonialCarousel from '@/components/common/Testimonial/TestimonialCarousel'

export default {
  name: 'Landing',
  components: {
    Button,
    PostThumbCarousel,
    TestimonialCarousel
  },
  metaInfo: {
    title: 'Scriv | Onde escritores e leitores se encontram',
    titleTemplate: null
  },
  data () {
    return {
      posts: null,
      testimonials: [
        {
          person_name: 'Lari Stella',
          person_image: '/images/pages/home/testimonial-lari.jpg',
          person_info: 'Scriver desde 09/11/2020',
          text: 'A Scriv me fortalecia e dava confiança à minha escrita. Quando eu vendi meus livros, me dei conta de que realizei o sonho de uma menina de 14 anos. Obrigada @scrivapp, vocês são incríveis!'
        },
        {
          person_name: 'Mandi Castro',
          person_image: '/images/pages/home/testimonial-mandi.jpg',
          person_info: 'Scriver desde 21/10/2020',
          text: 'Todos nós queremos ser lidos e comentados. Foi nesse caminho que a Scriv me encantou. Gostaria de convidar a todos a entrearem na plataforma e darem uma chance para sua própria voz.'
        },
        {
          person_name: 'Romulo Narducci',
          person_image: '/images/pages/home/testimonial-romulo.jpg',
          person_info: 'Scriver desde 13/04/2021',
          text: 'A Scriv é uma plataforma literária muito bacana na qual tenho orgulho de ser um dos autores e onde venho publicando e experimentando meus poemas e contos inéditos.'
        },
        {
          person_name: 'José Zamai',
          person_image: '/images/pages/home/testimonial-jose.jpg',
          person_info: 'Scriver desde 07/04/2021',
          text: 'A Scriv tem feito um importante trabalho de democratização, divulgação e estímulo da escrita. Obrigado a @scrivapp pelo   cuidado e sensibilidade que tem com seus usuários.'
        },
        {
          person_name: 'Giulianno Liberalli',
          person_image: '/images/pages/home/testimonial-giulianno.jpg',
          person_info: 'Scriver desde 05/04/2021',
          text: 'O que mais me agradou foi a receptividade da comunidade de leitores e escritores, muita gente talentosa. Essa é a satisfação do escritor: se comunicar e se fazer entender.'
        },
        {
          person_name: 'Ricardo Garcia',
          person_image: '/images/pages/home/testimonial-ricardo.jpg',
          person_info: 'Scriver desde 16/08/2021',
          text: 'Ser escritor é sobre isso, sobre dar e trazer memórias através de palavras. Obrigado @scrivapp pela oportunidade de escrever com vocês todos os dias.'
        }
      ]
    }
  },
  created () {
    this.getPosts()
  },
  methods: {
    async getPosts () {
      try {
        const posts = await FeedService.getFeedPosts({ type: 'trending', page: 1, items: 6 })
        this.posts = posts
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    }
  }
}
</script>
